import { render, staticRenderFns } from "./mpServiceAddress.vue?vue&type=template&id=20bc2ab6&scoped=true&"
import script from "./mpServiceAddress.vue?vue&type=script&lang=js&"
export * from "./mpServiceAddress.vue?vue&type=script&lang=js&"
import style0 from "./mpServiceAddress.vue?vue&type=style&index=0&id=20bc2ab6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bc2ab6",
  null
  
)

component.options.__file = "mpServiceAddress.vue"
export default component.exports